
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-rewriter?id=data-v-3f13c006!../node_modules/vue-loader/lib/selector?type=styles&index=0!./F3D.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./F3D.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-3f13c006!../node_modules/vue-loader/lib/selector?type=template&index=0!./F3D.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/F3D.vue
// module id = 7
// module chunks = 0